/**
 * Nombres de query param del contrato OAuth del MCP. Viven en `shared/` porque
 * tanto `modules/mcp/` (que arma las llamadas) como `modules/authentication/`
 * (que necesita reconocerlos para volver al consentimiento tras el login) los
 * consumen, e `import-boundaries.md` prohíbe que un módulo importe de otro.
 */
export const OAUTH_QUERY_PARAM_RESPONSE_TYPE = 'response_type';
export const OAUTH_QUERY_PARAM_CLIENT_ID = 'client_id';
export const OAUTH_QUERY_PARAM_REDIRECT_URI = 'redirect_uri';
export const OAUTH_QUERY_PARAM_STATE = 'state';
export const OAUTH_QUERY_PARAM_CODE_CHALLENGE = 'code_challenge';
export const OAUTH_QUERY_PARAM_CODE_CHALLENGE_METHOD = 'code_challenge_method';
/**
 * `resource` (RFC 8707): identifica el endpoint MCP, **no** la URL base de las llamadas.
 * Puede venir con el sufijo `/mcp`, y los endpoints OAuth viven en la raíz del servidor,
 * así que la base se deriva de este valor en vez de usarlo crudo.
 */
export const OAUTH_QUERY_PARAM_RESOURCE = 'resource';

/** Nombre de la ruta del módulo MCP a la que se vuelve tras autenticarse. */
export const MCP_OAUTH_AUTHORIZE_ROUTE_NAME = 'mcp-oauth-authorize';

/** Claves obligatorias del contrato OAuth del MCP. `state` queda afuera: es opcional. */
export const REQUIRED_MCP_QUERY_PARAM_KEYS = [
  OAUTH_QUERY_PARAM_RESPONSE_TYPE,
  OAUTH_QUERY_PARAM_CLIENT_ID,
  OAUTH_QUERY_PARAM_REDIRECT_URI,
  OAUTH_QUERY_PARAM_CODE_CHALLENGE,
  OAUTH_QUERY_PARAM_CODE_CHALLENGE_METHOD,
  OAUTH_QUERY_PARAM_RESOURCE,
] as const;
